import React, { useState } from 'react';
import './SupportTickets.css';

const sampleTickets = [
  { ticket: '182129', service: 'Internet Service', status: 'Open', time: '09-08-2025 04:26 AM', issue: '--' },
  { ticket: '181946', service: 'Internet Service', status: 'Incomplete', time: '07-28-2025 05:02 AM', issue: '--' },
  { ticket: '180590', service: 'Security Service', status: 'Open', time: '04-29-2025 02:37 AM', issue: 'Internet Outage' },
  { ticket: '179155', service: 'Internet Service', status: 'Open', time: '04-08-2025 05:58 AM', issue: 'Internet Outage' },
  { ticket: '176192', service: 'Security Service', status: 'Closed', time: '01-03-2025 11:57 AM', issue: 'Security System ZONE' },
];

const SupportTickets = () => {
  const [search, setSearch] = useState('');

  const filteredTickets = sampleTickets.filter((ticket) =>
    ticket.ticket.includes(search)
  );

  return (
    <div className="support-card">
      <div className="support-header">
        <h3>Support tickets</h3>
        <div className="search-box">
          <input
            type="text"
            placeholder="Search by ticket number"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
          <span className="search-icon">🔍</span>
        </div>
      </div>

      <table className="ticket-table">
        <thead>
          <tr>
            <th>Ticket Number</th>
            <th>Service</th>
            <th>Status</th>
            <th>Reported time</th>
            <th>Issue</th>
          </tr>
        </thead>
        <tbody>
          {filteredTickets.map((t) => (
            <tr key={t.ticket}>
              <td className="link">{t.ticket}</td>
              <td>{t.service}</td>
              <td>
                <span className={`status ${t.status.toLowerCase()}`}>
                  {t.status}
                </span>
              </td>
              <td>{t.time}</td>
              <td>{t.issue}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default SupportTickets;
